import {
  HIDE_TRANSACTION_MODAL,
  SHOW_TRANSACTION_MODAL,
} from '@/store/mutation-types';

export default {
  namespaced: true,
  state: {
    isTransactionModalVisible: false,
    noteId: '',
    transactions: [],
    noteOpenedOn: '',
  },
  mutations: {
    [HIDE_TRANSACTION_MODAL](state) {
      state.isTransactionModalVisible = false;
      state.noteId = '';
      state.transactions = [];
    },
    [SHOW_TRANSACTION_MODAL](state, note) {
      state.isTransactionModalVisible = true;
      state.noteId = note.id;
      state.transactions = note.transactions;
      state.noteOpenedOn = note.openedOn;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/transactionModal.js